// extracted by mini-css-extract-plugin
var _1 = "styles_productList__A9goc";
var _2 = "styles_shipment__KjDpA";
export { _1 as "productList", _2 as "shipment" }
